import AVdxbSectionDivider from './index.vue';

AVdxbSectionDivider.install = app => {
  app.component(AVdxbSectionDivider.name, AVdxbSectionDivider);
};

export default AVdxbSectionDivider;
